<bs-global-header></bs-global-header>

<div class="master-body content-container">
    <router-outlet></router-outlet>
</div>

<bs-toasts></bs-toasts>
<div
    class="global-drawer-swiper"
    bsSwipeTrigger="right"
    (bsSwipeTriggerHandler)="toggleDrawer()"
></div>
@if (isWriteImpersonation) {
<div class="global-impersonation-warn"></div>
} @if (globalLoadingState?.active) {
<div class="global-in-app-loader">
    <bs-progress-bar [indeterminate]="true"></bs-progress-bar>
</div>
}
